import { render, staticRenderFns } from "./AppendixBottom.vue?vue&type=template&id=12ec3816&scoped=true"
import script from "./AppendixBottom.vue?vue&type=script&lang=js"
export * from "./AppendixBottom.vue?vue&type=script&lang=js"
import style0 from "./AppendixBottom.vue?vue&type=style&index=0&id=12ec3816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ec3816",
  null
  
)

export default component.exports